import { logger } from '@/lib/logger';
import { systemConfig } from '@/config/system.config';
import { trySsoSilentLogin } from '@/services/auth/auth.service';
import { useAuthStore } from '@/store/auth.store';
import {
  getInitialUrlHadB2CIdToken,
  getInitialB2CIdToken,
  waitForAuthStoreHydration,
} from '@cliv-portal-auth/bootstrap';

const AUTH_LOG = '[supplier-auth]';

export { getInitialUrlHadB2CIdToken, getInitialB2CIdToken };

export const initialUrlHadB2CIdToken = getInitialUrlHadB2CIdToken();
export const initialB2CIdToken = getInitialB2CIdToken();

/** Single bootstrap run shared across remounts (e.g. React Strict Mode). */
let authBootstrapPromise: Promise<void> | null = null;

/** Tests: reset module-level bootstrap so each test can re-run SSO. */
export function __resetAuthBootstrapForTests(): void {
  authBootstrapPromise = null;
}

export function runAuthBootstrap(): Promise<void> {
  if (authBootstrapPromise) {
    return authBootstrapPromise;
  }
  authBootstrapPromise = (async () => {
    await waitForAuthStoreHydration(useAuthStore);
    if (useAuthStore.getState().token) {
      logger.debug(AUTH_LOG + ' App bootstrap: skip trySsoSilentLogin — already have token');
      return;
    }
    if (initialUrlHadB2CIdToken) {
      logger.debug(
        AUTH_LOG +
          ' App bootstrap: skip trySsoSilentLogin — B2C id_token was present on initial URL'
      );
      return;
    }
    if (!systemConfig.tenantId) {
      logger.debug(AUTH_LOG + ' App bootstrap: skip trySsoSilentLogin — no build-time tenantId');
      return;
    }
    logger.debug(AUTH_LOG + ' App bootstrap: trySsoSilentLogin()');
    const data = await trySsoSilentLogin();
    if (data?.accessToken && data.user && data.tenantId) {
      useAuthStore.getState().login(data.accessToken, data.user, data.tenantId);
    }
  })();
  return authBootstrapPromise;
}
